// Note: The daysShort and daysMin values are the same in this object. That's intentional; the air-datepicker only
// displays daysMin for the calendar's headings, but we want the three-letter days.
export const localization = {
  days: [
    window.gettext("Sunday"),
    window.gettext("Monday"),
    window.gettext("Tuesday"),
    window.gettext("Wednesday"),
    window.gettext("Thursday"),
    window.gettext("Friday"),
    window.gettext("Saturday"),
  ],
  daysShort: [
    window.gettext("Sun"),
    window.gettext("Mon"),
    window.gettext("Tue"),
    window.gettext("Wed"),
    window.gettext("Thu"),
    window.gettext("Fri"),
    window.gettext("Sat"),
  ],
  daysMin: [
    window.gettext("Sun"),
    window.gettext("Mon"),
    window.gettext("Tue"),
    window.gettext("Wed"),
    window.gettext("Thu"),
    window.gettext("Fri"),
    window.gettext("Sat"),
  ],
  months: [
    window.gettext("January"),
    window.gettext("February"),
    window.gettext("March"),
    window.gettext("April"),
    window.gettext("May"),
    window.gettext("June"),
    window.gettext("July"),
    window.gettext("August"),
    window.gettext("September"),
    window.gettext("October"),
    window.gettext("November"),
    window.gettext("December"),
  ],
  monthsShort: [
    window.gettext("Jan"),
    window.gettext("Feb"),
    window.gettext("Mar"),
    window.gettext("Apr"),
    window.gettext("May"),
    window.gettext("Jun"),
    window.gettext("Jul"),
    window.gettext("Aug"),
    window.gettext("Sep"),
    window.gettext("Oct"),
    window.gettext("Nov"),
    window.gettext("Dec"),
  ],
  today: window.gettext("Today"),
  clear: window.gettext("Clear"),
  // eslint-disable-next-line i18next/no-literal-string
  dateFormat: "MMM dd, yyyy",
  // eslint-disable-next-line i18next/no-literal-string
  timeFormat: "hh:ii aa",
  firstDay: 0,
};
